export default "__VITE_ASSET__Cymo8Xb7__"